import React , { Component } from 'react'
import { connect } from 'react-redux'
import { dispatchActions } from 'components/bundle/bundleHandlerRedux'
import { Redirect } from 'react-router-dom'

import LoadingSpinner from 'components/common/LoadingSpinner'

import Bundle from 'components/bundle/v1'

class BundleHandler extends Component {
	componentDidMount() {
		const { bundleId } = this.props.match.params;
		this.props.fetchBundleById(bundleId);
	}

	render() {
		const { bundleId } = this.props.match.params;
		const { isLoading, error, bundle } = this.props.bundleHandler;

		if (isLoading) return <LoadingSpinner message={`Bundle wird geladen...`}/>;
		if (error) return <Redirect to={'/home'} />;

		return bundle && <Bundle bundleId={bundleId}/>;
	}
}

const mapStateToProps = (state) => {
	return {
		bundleHandler: state.bundleHandler
	}
};

export default connect(mapStateToProps, dispatchActions)(BundleHandler);



// WEBPACK FOOTER //
// ./src/components/bundle/BundleHandler.jsx